const PreMarketClosedFlag = ({ isClosed }) => (
  <div className="property-card-flag property-card-flag--new-property" data-test-reference="market_closed_flag">
    <div className="property-card-flag--emphasized-text-md">VOTE<br/>{ isClosed ? <small>CLOSED</small> : 'OPEN' }</div>
  </div>
);

export default PreMarketClosedFlag;
